'use strict';
var angular = require('angular');
var RxCredentialAddService = /** @class */ (function () {
    function RxCredentialAddService($http) {
        'ngInject';
        this.$http = $http;
        // Object to store our user properties
        this.current = null;
    }
    RxCredentialAddService.prototype.handleSuccess = function (response) {
        return response;
    };
    RxCredentialAddService.prototype.handleError = function (response) {
        return response;
    };
    RxCredentialAddService.prototype.getRegionsForCountry = function (countryCode) {
        var request = this.$http({
            method: 'GET',
            url: "api/admin/regions/" + countryCode,
            params: {
                action: 'get'
            }
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    RxCredentialAddService.prototype.getRxDoctorTypes = function () {
        var request = this.$http.get('api/admin/rxdoctortypes');
        return (request.then(this.handleSuccess, this.handleError));
    };
    return RxCredentialAddService;
}());
export default RxCredentialAddService;
//# sourceMappingURL=rx-credential-add.service.js.map